import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { featureArticles } from '@/mocks/articles';

export default function FeatureGrid() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            {t('featureSectionTitle')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            {t('featureSectionSubtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-foreground-950 rounded-xl p-6 flex flex-col justify-between">
            <div>
              <div className="w-12 h-12 rounded-full bg-foreground-800 flex items-center justify-center">
                <i className="ri-fire-line text-accent-400 text-xl" />
              </div>
              <div className="mt-6">
                <span className="text-3xl md:text-4xl font-heading font-bold text-background-50">2,340+</span>
                <p className="mt-2 text-sm text-foreground-400">累计独家爆料</p>
              </div>
            </div>
            <Link
              to="/category/exclusive"
              className="whitespace-nowrap mt-6 inline-flex items-center gap-1 text-sm text-accent-400 hover:text-accent-300 transition-colors cursor-pointer"
            >
              查看独家内容
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="md:col-span-1">
            <ArticleCard
              slug={featureArticles[0].slug}
              title={featureArticles[0].title}
              excerpt={featureArticles[0].excerpt}
              category={featureArticles[0].category}
              categorySlug={featureArticles[0].categorySlug}
              imageUrl={featureArticles[0].imageUrl}
              date={featureArticles[0].date}
              viewCount={featureArticles[0].viewCount}
              commentCount={featureArticles[0].commentCount}
              variant="feature"
            />
          </div>

          <div className="flex flex-col gap-4">
            <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
              <span className="text-xs text-accent-600 font-medium">{featureArticles[1].category}</span>
              <h3 className="mt-2 text-lg font-heading font-bold text-foreground-900 leading-snug">
                {featureArticles[1].title}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                {featureArticles[1].excerpt}
              </p>
              <Link
                to={`/article/${featureArticles[1].slug}`}
                className="whitespace-nowrap mt-4 inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {t('readMore')}
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
            <div className="flex-1 rounded-xl overflow-hidden relative">
              <img
                src="https://readdy.ai/api/search-image?query=Entertainment%20news%20breaking%20alert%20concept%20with%20glowing%20notification%20on%20dark%20surface%2C%20dramatic%20warm%20lighting%2C%20coral%20accents%2C%20editorial%20concept%20photography%2C%20clean%20minimal%20background%2C%20urgent%20news%20aesthetic&width=800&height=600&seq=feat-extra-n8m2&orientation=landscape"
                alt="更多爆料"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-5">
                <Link
                  to="/category/all"
                  className="whitespace-nowrap text-sm font-medium text-background-50 hover:text-accent-300 transition-colors cursor-pointer flex items-center gap-1"
                >
                  浏览更多内容
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}